import { Start, Stop } from 'smg/buttons';
import { CreateFormSubmissionWithReCaptcha } from 'smg/customer-api/formsubmissions';
import * as models from 'smg/customer-api/models';
import { PromotionalCode } from 'smg/customer-api/promos';
import { NewQuoteRequest } from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import * as enhancedconversions from 'smg/enhanced-conversions';
import { ShowError } from 'smg/errors';
import { BlockPastDates, ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import QueryString from 'smg/querystring';
import { Uploader } from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { QuoteReceivedURL } from '../quote-form-success';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

main();

function main() {
    const $preform = document.querySelector('#pre-form') as HTMLFormElement;
    const $form = document.querySelector('#form') as HTMLFormElement;

    const $preformFieldset = $preform.querySelector('fieldset') as HTMLFieldSetElement;
    const $firstStep = $preform.querySelector('#first-step') as HTMLElement;
    const $email = $firstStep.querySelector('#email') as HTMLInputElement;
    const $emailSubmitBtn = $firstStep.querySelector('#first-step-continue') as HTMLButtonElement;
    const $reCaptchaPlaceholder = $firstStep.querySelector('.contact-recpatcha-parent') as HTMLElement;

    $preform.querySelectorAll<HTMLInputElement>('input[name="sport"]').forEach($radio => {
        $radio.addEventListener('input', () => {
            if ($radio.checked) {
                if ($radio.value === 'Baseball') {
                    $form.querySelector('.step.template.baseball')?.classList.remove('d-none');
                    $form.querySelector('.step.size.baseball')?.classList.remove('d-none');
                    $form.querySelector('.step.template.softball')?.classList.add('d-none');
                    $form.querySelector('.step.size.softball')?.classList.add('d-none');
                } else if ($radio.value === 'Softball') {
                    $form.querySelector('.step.template.softball')?.classList.remove('d-none');
                    $form.querySelector('.step.size.softball')?.classList.remove('d-none');
                    $form.querySelector('.step.template.baseball')?.classList.add('d-none');
                    $form.querySelector('.step.size.baseball')?.classList.add('d-none');
                }
            }
        });
    });

    $preform.noValidate = true;
    $preform.addEventListener('submit', async e => {
        e.preventDefault();
        $email.setCustomValidity('');
        if (!ReportValidity($preform)) {
            return false;
        }

        Start($emailSubmitBtn);
        $preformFieldset.disabled = true;

        const email = $email.value;

        let flagIDs: models.FlagID[] = [models.FlagID.FLAG_PRE_FORM_EMAIL];

        const $selected = $preform.querySelector<HTMLInputElement>('input[name="sport"]:checked');
        if ($selected?.value === 'Baseball') {
            flagIDs = [models.FlagID.FLAG_BASEBALL_PRE_FORM_USER, models.FlagID.FLAG_BASEBALL];
        } else if ($selected?.value === 'Softball') {
            flagIDs = [models.FlagID.FLAG_SOFTBALL_PRE_FORM_USER, models.FlagID.FLAG_SOFTBALL];
        }

        // The capture persists as an `email-capture` form submission (#7260);
        // the routing automation does the user create/attach + flag
        // assignment, so revealing the full form waits only on the submission.
        await CreateFormSubmissionWithReCaptcha({
            form: 'email-capture',
            variant: 'new-trading-pin',
            payload: {
                email,
                flagIDs,
            },
        }, {
            $reCaptchaPlaceholder,
            action: 'email_capture',
        }).then(() => {
            const $formEmail = $form.querySelector<HTMLInputElement>('#email') as HTMLInputElement;
            $formEmail.value = email;
            $form.classList.remove('d-none');
            $emailSubmitBtn.parentElement?.classList.add('d-none');
            $form.scrollIntoView({
                behavior: 'smooth',
            });
        }).catch(err => {
            ShowError(err, $firstStep);
        }).finally(() => {
            $preformFieldset.disabled = false;
            Stop($emailSubmitBtn);
        });
    });

    const radios = $form.querySelectorAll<HTMLInputElement>('input[type="radio"]');
    radios.forEach(radio => radio.addEventListener('click', () => {
        const step = radio.closest('.step') as HTMLElement;
        let nextStep: HTMLElement;

        if (radio.name === 'template') {
            if (radio.closest('.step.template.baseball')) {
                nextStep = step.parentElement?.querySelector('.step.size.baseball') as HTMLElement;
            } else {
                nextStep = step.parentElement?.querySelector('.step.size.softball') as HTMLElement;
            }
        } else if (radio.name === 'sizes') {
            nextStep = step.parentElement?.querySelector('.step.plating') as HTMLElement;
        } else {
            nextStep = step.nextElementSibling as HTMLElement;
        }

        if (nextStep) {
            nextStep.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }));

    const fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;
    const submit = $form.querySelector('[type="submit"]') as HTMLButtonElement;

    const quantity = $form.querySelector('#quantity') as HTMLInputElement;
    const dateEl = $form.querySelector('#date') as HTMLInputElement;
    BlockPastDates(dateEl, { earliest: 'tomorrow' });
    const budget = $form.querySelector('#budget') as HTMLSelectElement;
    const team = $form.querySelector('#team') as HTMLInputElement;
    const colors = $form.querySelector('#colors') as HTMLInputElement;
    const notes = $form.querySelector('#notes') as HTMLTextAreaElement;
    const promo = $form.querySelector('#promo') as HTMLInputElement;

    const fullName = $form.querySelector('#full-name') as HTMLInputElement;
    const email = $form.querySelector('#email') as HTMLInputElement;
    const phone = $form.querySelector('#phone') as HTMLInputElement;

    const u = new Uploader(document.querySelector('#uploads') as HTMLLabelElement, {
        confirmBtn: submit || undefined,
    });

    const p = new Phone(phone);

    promo.value = QueryString().get('promo') ?? '';

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        const startLoading = () => {
            fieldset.disabled = true;
            Start(submit);
        };
        const stopLoading = () => {
            fieldset.disabled = false;
            Stop(submit);
        };

        startLoading();

        promo.setCustomValidity('');
        if (promo.value) {
            promo.setCustomValidity('The promo code is not valid.');
            try {
                const promotionalCode = await PromotionalCode(promo.value);
                if (promotionalCode.promotionalCodeID) {
                    promo.setCustomValidity('');
                }
            } catch (err) {
                console.error(err);
            }
        }

        stopLoading();
        if (!ReportValidity($form)) {
            return false;
        }
        startLoading();

        const sport = $preform.querySelector('[name="sport"]:checked') as HTMLInputElement;
        const size = $form.querySelector('[name="sizes"]:checked') as HTMLInputElement;
        const template = $form.querySelector('[name="template"]:checked') as HTMLInputElement;
        const plating = $form.querySelector('[name="plating"]:checked') as HTMLInputElement;
        const upgrades = $form.querySelectorAll('[name="upgrades"]:checked');

        const extras: models.QuoteRequestCreateExtra[] = [];

        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Sport',
            value: sport.value,
        }));

        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Template',
            value: template.value,
        }));

        if (colors) {
            if (colors.value) {
                extras.push(new models.QuoteRequestCreateExtra({
                    name: 'Colors',
                    value: colors.value,
                }));
            }
        }

        if (team?.value) {
            extras.push(new models.QuoteRequestCreateExtra({
                name: 'Team',
                value: team.value,
            }));
        }

        extras.push(new models.QuoteRequestCreateExtra({
            name: 'Budget',
            value: budget.value,
        }));

        const children: models.QuoteRequestCreateChild[] = [];

        children.push(new models.QuoteRequestCreateChild({
            child: 'Plating',
            option: plating.value,
        }));

        upgrades.forEach(upgrade => {
            const upgradeEl = upgrade as HTMLInputElement;
            children.push(new models.QuoteRequestCreateChild({
                child: upgradeEl.value,
            }));
        });

        // Awaited outside the chain — a PUT-failure throw would otherwise skip
        // the catch below and leave the form loading.
        let uploadIDs: number[];
        try {
            uploadIDs = await u.getUploadIDs();
        } catch (err) {
            stopLoading();
            ShowError(err, $form);
            return;
        }

        void NewQuoteRequest({
            form: 'start a trading pin design',
            company: team?.value || '',
            email: email?.value || '',
            name: fullName?.value || '',
            phone: await p.format(),

            dateNeeded: dateEl.value || undefined,
            lineItem: 'Lapel Pins',
            type: 'Trading Pins',
            size: size.value,
            extras,
            children,

            uploadIDs,
            project: `${new Date().getFullYear()} ${team ? team.value : ''}`,
            notes: notes?.value || '',
            promo: promo.value,
            quantity: parseInt(quantity?.value, 10) || 0,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String(fullName.value));
            // The event carries the module's gated view so bare names without
            // a complete address never reach Google (#9198 class 3).
            const userData = enhancedconversions.Set({
                email: sess?.user.emailAddress.email || email.value,
                phone: sess?.user.phoneNumber.phone || await p.format(),
                firstName: sess?.user.firstName || firstName,
                lastName: sess?.user.lastName || lastName,
            });
            dataLayer.push({
                'event': 'hugo-new-trading-pin-quote-request',
                'userData': { ...userData },
                'transactionId': quoteRequest.id,
                // 'products': gtmProducts,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });

            window.location.href = QuoteReceivedURL(quoteRequest);
        }).catch(err => {
            stopLoading();

            ShowError(err, $form);
        });
    });

    const getCurrentOverlapTarget = (): HTMLElement | null => {
        const form = document.querySelector('#form');
        const contact = document.querySelector('#contact');
        const firstStep = document.querySelector('#first-step');

        if (!form || !contact || !firstStep) {
            return null;
        }

        if (!form.classList.contains('d-none')) {
            return contact as HTMLElement;
        }

        return firstStep as HTMLElement;
    };

    const getPodiumWidget = () => document.querySelector<HTMLElement>('#podium-website-widget');

    const getPodiumTop = (): number => {
        const iframe = document.querySelector('#podium-website-widget iframe');
        return iframe?.getBoundingClientRect().top ?? Infinity;
    };

    const getTargetBottom = (): number => {
        const target = getCurrentOverlapTarget();
        return target?.getBoundingClientRect().bottom ?? 0;
    };

    let ticking = false;
    const updatePodiumOffset = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const podiumTop = getPodiumTop();
                const targetBottom = getTargetBottom();

                if (podiumTop < targetBottom) {
                    getPodiumWidget()?.classList.add('opacity-0', 'pe-none');
                } else {
                    getPodiumWidget()?.classList.remove('opacity-0', 'pe-none');
                }

                ticking = false;
            });

            ticking = true;
        }
    };

    window.addEventListener('resize', updatePodiumOffset);
    window.addEventListener('scroll', updatePodiumOffset);

    const waitForPodiumLoad = () => {
        const iframe = document.querySelector('#podium-website-widget iframe');
        if (iframe) {
            updatePodiumOffset();
        } else {
            requestAnimationFrame(waitForPodiumLoad);
        }
    };

    waitForPodiumLoad();
}
